/**
 * A presença do portal (D3, passo 19 — PR 2; PR 1, Decisão 3). A entrada da aba no servidor só vale 60 s (`ABA_FRESCA_SECONDS`, `presence/abas.py`),
 * mas é o SERVIDOR que a renova sozinho a cada 30 s (`PERIODO_DA_PRESENCA`): o cliente só diz `{"type":"aba","visivel":<a aba está à vista>}`
 * ao abrir o socket e quando a visibilidade MUDA (`visibilitychange`). Sem isto o servidor presume a aba à vista e o push da Central e da
 * resposta não sai com ela escondida. Sem batimento no cliente. Só com o socket aberto; o interno NÃO manda nada. `enviar` vai por ref: a
 * função nova a cada render não reenvia nem duplica o ouvinte.
 */
import { useEffect, useRef } from "react";

export function usePresencaDoPortal(
  enviar: (mensagem: unknown) => boolean,
  conectado: boolean
): void {
  const enviarRef = useRef(enviar);
  enviarRef.current = enviar;

  useEffect(() => {
    if (!conectado) return;
    const mandar = () => {
      enviarRef.current({ type: "aba", visivel: document.visibilityState === "visible" });
    };
    mandar();
    document.addEventListener("visibilitychange", mandar);
    return () => document.removeEventListener("visibilitychange", mandar);
  }, [conectado]);
}
